import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import { Subscription, timer } from 'rxjs';
import { Region } from 'src/app/model/region.model';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { School } from 'src/app/model/school.model';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { DataMonitoringService } from '../service/data-monitoring.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { UtilityService } from 'src/app/service/utility.service';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import moment from 'moment';
import { MatTableDataSource } from '@angular/material/table';
import { MatCardTitle, MatCard } from '@angular/material/card';
import { CommonComponentsModule } from '../../common-components/common-components.module';
import { MatDivider } from '@angular/material/divider';
import { environment } from 'src/environments/environment';
import { SearchStudentResponseDataView } from 'src/app/model/reports/exportsModels';
import { DataMonitoringReportEnrollmentResult } from '../model/data-monitoring-report-enrollment-result.model';
import { provisionalSchoolReport } from '../model/provisional-school-report';
import { ResolveProvisionalSchoolModalComponent } from '../../children/edit-child/edit-child-enrollment/resolve-provisional-school-modal/resolve-provisional-school-modal.component';
import { SchoolEnrollment } from '../../children/model/school-enrollment.model';

@Component({
    selector: 'app-provisional-school',
    templateUrl: './provisional-school.component.html',
    styleUrl: './provisional-school.component.scss'
})
export class ProvisionalSchoolComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appDistrictCode') appDistrictCode!: DistrictDropdownComponent;
    @ViewChild('appSchools') appSchools!: SchoolDropdownComponent;
    @Input() searchParm: any = [{}];
    public data: { sIds: number[]; performancePeriod: string; mpoNumber: number; fileNameLabel: string };
    isLoadingResults: boolean = false;
    isExporting: boolean = false;

    progressCurrentValue: number = 10;
    progressValue: number = 10;
    progressMax: number = 200;
    progressSpinnerMax: number = 100;
    progressColor: ThemePalette = 'accent';
    progressType: ProgressSpinnerMode = 'determinate';
    progressSpeed: number = 50;

    progressSubscription: Subscription;
    progressInterval: number = 500;
    lstStudentsResponseDataView: provisionalSchoolReport[] = [];

    strExportFileName = 'no file name';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    currentSetting: any;

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedSchool: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];
    chosenSchoolYear: string = '';

    startingSchoolYearDate: Date;

    // Component variables
    resetField: boolean = false;

    // Table display
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSource!: MatTableDataSource<provisionalSchoolReport>;

    lstSearchProvisionResponseDataView: provisionalSchoolReport[] = [];

    // Results
    results: provisionalSchoolReport[] = [];
    filter: string = '';

    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        private dataMonitoringService: DataMonitoringService,
        router: Router,
        private dialog: MatDialog,
        //  public routeGuardService: RouteGuardService,
        private urlProvider: UrlProviderService,
        private utilityService: UtilityService,
        private apiMsinExportsService: ApiExportsService
    ) {
        this.connectAPIs(dataMonitoringService);
        this.selectSettings(router.url);
        this.setStartingSchoolYearDate();
    }
    ngOnInit(): void {
        throw new Error('Method not implemented.');
    }

    connectAPIs(dataMonitoringService: DataMonitoringService) {
        this.settings['/data-monitoring-reports/provisional-schools'].API = function (payload: any) {
            return dataMonitoringService.getProvisionalSchool(payload);
        };
    }
    selectSettings(url: string) {
        this.currentSetting = this.settings[url];
    }
    setStartingSchoolYearDate() {
        // Set the cut-off day to go to next school year (the week after the 3rd Friday in Sept)
        let mDate = moment({ month: 8, day: 1 }); // month is 0 based

        // By default we will need to add two weeks to the first friday
        let nWeeks = 2;
        let month = mDate.month();

        // Get first Friday of the first week of the month
        mDate = mDate.date(1).day(5);

        // Check if first Friday is in the given month
        //  it may have gone to the previous month
        if (mDate.month() != month) {
            nWeeks++;
        }

        this.startingSchoolYearDate = mDate.add(nWeeks, 'weeks').add(3, 'days').toDate();
    }
    search() {
        if (this.checkValid()) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.currentSetting.API(this.generatePayload()).subscribe({
                next: (res: any) => {
                    console.log('API returned:');
                    console.log(res);
                    if (res.students) {
                        console.log('has students');
                        console.log(res.students);
                        this.results = res.students.sort((n1: provisionalSchoolReport, n2: provisionalSchoolReport) =>
                            n1.STUDENTS_ID! > n2.STUDENTS_ID! ? 1 : -1
                        );

                        this.displayedColumns = this.currentSetting.COLUMNS;

                        // Updates the Tables to be displayed w/ this.results
                        this.updateDataSource();
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                    }
                },
                error: (err: any) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving ' + this.currentSetting.TITLE + '.' };
                },
                complete: () => {
                    // Display current performance period
                    this.currentSchoolYear = this.selectedSchoolYear;
                    this.currentPerformancePeriod = this.selectedPerformancePeriod;

                    // Display results
                    this.isLoading = false;
                }
            });
        }
    }
    checkValid() {
        if (this.chosenRegions.length > 0 && (this.selectedSchoolYear || this.selectedPerformancePeriod)) {
            return true;
        }

        return false;
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.toNumberArray(this.chosenRegions);
        //payload.chosenCounties = this.toNumberArray(this.chosenCounties);
        //payload.chosenSchoolDistricts = this.toNumberArray(this.chosenSchoolDistricts);
        //payload.chosenSchools = this.toNumberArray(this.chosenSchools);
        payload.schoolYear = this.selectedSchoolYear;
        //payload.performancePeriod = this.selectedPerformancePeriod;
        payload.columns = [];
        return payload;
    }
    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }
    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<provisionalSchoolReport>();
            this.tableDataSource.data = this.results;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };
        });
    }

    schoolYearEvent(schoolYear: string) {
        this.selectedSchoolYear = schoolYear;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedPerformancePeriod = performancePeriod;
    }
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.msg = {};
    }

    resolveProvisionalSchoolDialog(provisionalSchoolEnrollment?: any) {
        let payload: any = {};
        if (provisionalSchoolEnrollment) {
            payload.provisionalSchoolEnrollment = provisionalSchoolEnrollment;
        }

        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.data = payload;
        dialogConfig.maxHeight = '99vh';
        dialogConfig.minWidth = '95vw';
        const dialogRef = this.dialog.open(ResolveProvisionalSchoolModalComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((res: any) => {
            if (res) {
                if (res.refresh) {
                    this.search();
                }
            }
        });
    }

    downloadXLS() {
        this.isExporting = true;
        this.isLoadingResults = true;
        console.log('now download xls');
        let rowCount = this.lstStudentsResponseDataView.length;
        this.downloadXLSCore(false);
    }

    downloadXLSCore(bViaPost: boolean) {
        console.log('now downstreaming XLS file :');

        this.lstSearchProvisionResponseDataView = this.tableDataSource.data;

        this.isExporting = true;
        this.progressMax = this.lstSearchProvisionResponseDataView.length;
        console.log('set progressMax at:');
        console.log(this.progressMax);
        this.progressValue = 10;
        this.progressCurrentValue = 10;
        this.progressValue = (1 / this.progressMax) * 100;

        console.log('initial progressValue=');
        console.log(this.progressValue);
        //   console.log(this.settings['/data-monitoring-reports/missing-withdrawal-date'].COLUMNS)

        this.chosenSchoolYear = this.selectedSchoolYear?.toString();
        this.chosenRegions = this.appRegionCode.selectedRegionIds.map((num: number) => this.CreateRegionFromNumber(num));
        this.chosenCounties = this.appCountyCode.selectedCountyIds.map((num: number) => this.CreateCountyFromNumber(num));
        this.chosenSchoolDistricts = this.appDistrictCode.selectedSchoolDistrictIds.map((num: number) => this.CreateDistrictFromNumber(num));
        this.chosenSchools = this.appSchools.selectedSchoolIds.map((num: number) => this.CreateSchoolFromNumber(num));

        const htmlContent = 'test';
        this.strExportFileName = this.currentSetting.EXPORTFILENAME;
        let strTemplateName = this.strExportFileName;

        let urlWithParms = environment.apiUrlMsinExportsAPI + '/SSDP';

        try {
            this.lstStudentsResponseDataView = this.results;

            this.searchParm = this.generatePayload();
            this.searchParm.chosenRegions = JSON.stringify(this.chosenRegions);
            this.searchParm.strExportType = 'XLS';
            this.searchParm.studentIds = JSON.stringify(this.lstStudentsResponseDataView); //this.toNumberArray(
            this.searchParm.Template_Name = strTemplateName;
            this.searchParm.chosenCounties = JSON.stringify(this.chosenCounties); //this.toNumberArray(this.chosenCounties);
            this.searchParm.chosenSchoolDistricts = JSON.stringify(this.chosenSchoolDistricts);
            this.searchParm.chosenSchools = JSON.stringify(this.chosenSchools);
            this.searchParm.performancePeriod = this.performancePeriodEvent;
            this.searchParm.strFileName = strTemplateName;
            this.searchParm.strYear = this.chosenSchoolYear;
            this.searchParm.fileNameLabel = this.fileNameLabel;
            this.searchParm.bCheckedStyling = this.bCheckedStyling.toString();
            this.searchParm.grade = '';
            this.searchParm.age = '';
            this.searchParm.enrollmentDate = '';
            this.searchParm.enrollmentType = '';
            this.searchParm.columns = this.currentSetting.COLUMNS;
            this.searchParm.columnHeaders = this.currentSetting.COLUMN_HEADERS;
            this.searchParm.columnWidths = this.currentSetting.COLUMN_WIDTHS;
            this.searchParm.file_name_label = this.currentSetting.TITLE;
            console.log('passing searchParm');
            console.log(this.searchParm);

            console.log('generating report via replaceurl');
            console.log(this.searchParm.strFileName);
            console.log('and ' + this.searchParm.fileNameLabel);
            if (this.searchParm.strFileName.toLowerCase().startsWith('Age_Eligible'.toLowerCase())) {
                console.log('in xls bracket');
                this.progressSpeed = this.progressSpeed; //(this.progressSpeed/1.8) +(this.progressMax/4);
            } else if (
                this.searchParm.strFileName.toLowerCase().startsWith('Missing_Departure_Date_And_Summer-Intersession_Service'.toLowerCase()) ||
                this.searchParm.strFileName.toLowerCase().startsWith('Eligible_Enrolled_Not_Served'.toLowerCase())
            ) {
                this.progressSpeed = this.progressSpeed / 1.7 + this.progressMax / 3;
            } else if (this.searchParm.strFileName.toLowerCase().startsWith('Missing_Withdrawal_Date'.toLowerCase())) {
                this.progressSpeed = this.progressSpeed / 4 + this.progressMax / 7;
            } else if (this.searchParm.strFileName.toLowerCase().startsWith('N_Enrollment_and_Not_EIP'.toLowerCase())) {
                this.progressSpeed = this.progressSpeed / 1.7;
            }
            const progressInterval = setInterval(() => {
                // this corresponds to 100% of the spinner rotation
                if (this.progressCurrentValue >= this.progressSpinnerMax) {
                    clearInterval(progressInterval);
                    this.isExporting = false;
                }
                this.progressCurrentValue += 1;
                this.progressValue = (this.progressCurrentValue / this.progressMax) * 100;
                console.log('cur value is: ');
                console.log(this.progressValue);
                console.log(this.progressCurrentValue);
            }, this.progressSpeed); // spinner speed, smaller value=faster

            setTimeout(
                // progresses the spinner
                () => {
                    this.apiMsinExportsService
                        .getDtMonEnrollmentsXLSViaPost(this.searchParm)
                        .then(() => {
                            //clearInterval(progressInterval);
                            console.log('cleared interval via 2');
                            //   this.isExporting = false;
                        })
                        .catch((error) => {
                            console.error('Error in getDtMonEnrollmentsXLSViaPost():', error);
                        });
                },
                1000
            );
        } catch (Err) {
            console.log('Error running filestream XLS export: ');
            console.log(Err);
        }
    }

    CreateRegionFromNumber(num: number) {
        let oRegion: Region = new Region();
        oRegion.CODE = num.toString();
        return oRegion;
    }

    CreateCountyFromNumber(num: number) {
        let oCounty: County = new County();
        oCounty.COUNTY_CODE = num.toString();
        return oCounty;
    }

    CreateDistrictFromNumber(num: number) {
        let oDistrict: SchoolDistrict = new SchoolDistrict();
        oDistrict.CODE = num.toString();
        return oDistrict;
    }

    CreateSchoolFromNumber(num: number) {
        let oSchool: School = new School();
        oSchool.SCHOOL_CODE = num;
        return oSchool;
    }
    setFilter() {
        this.tableDataSource.filter = this.filter.trim().toLocaleLowerCase();
    }

    settings: any = {
        '/data-monitoring-reports/provisional-schools': {
            TITLE: 'Provisional Schools',
            EXPORTFILENAME: '',
            API: undefined,
            SCHOOL_YEAR: true,
            PERFORMANCE_PERIOD: false,
            HELP_TEXT_ID: 'DataMonitoring_Provisional-Schools',
            COLUMN_HEADERS: ['EDIT', 'Region', 'School Year', 'District', 'School', 'MSD Number', 'SSID', 'Name', 'DOB', 'Grade'],
            COLUMN_WIDTHS: [100, 28, 35, 100, 100, 40, 30, 75, 22, 22],
            COLUMNS: ['EDIT', 'Region', 'School Year', 'District', 'School', 'MSD Number', 'SSID', 'Name', 'DOB', 'Grade']
        }
    };
}
